export default __webpack_public_path__ + "static/media/gujarati_lang.e83dc58b.png";